import React from 'react';
import PropTypes from 'prop-types';
import ArrowDownIcon from 'dibs-vg/dist/react/arrow-down';
import ArrowUpIcon from 'dibs-vg/dist/react/arrow-up';

import styles from './FaqItem.scss';

export default class EnvelopeLabel extends React.Component {
    constructor(props) {
        super(props);
        this.toggleExpanded = this.toggleExpanded.bind(this);
        this.toggleIcon = this.toggleIcon.bind(this);

        this.state = {
            isExpanded: false,
        };
    }

    toggleExpanded(e) {
        e.preventDefault();
        const { isExpanded } = this.state;
        this.setState({ isExpanded: !isExpanded });
    }

    toggleIcon() {
        const arrowProps = {
            className: styles.toggleArrow,
        };

        return this.state.isExpanded ? (
            <ArrowUpIcon {...arrowProps} />
        ) : (
            <ArrowDownIcon {...arrowProps} />
        );
    }

    render() {
        let containerClass;
        let headerClass;
        let containerClick;
        let toggleIconClick;

        if (this.state.isExpanded) {
            containerClass = styles.containerExpanded;
            headerClass = styles.headerExpanded;
            toggleIconClick = this.toggleExpanded;
        } else {
            containerClass = styles.containerCollapsed;
            headerClass = styles.headerCollapsed;
            containerClick = this.toggleExpanded;
        }

        return (
            <div className={containerClass} onClick={containerClick}>
                <div className={styles.top}>
                    <div className={headerClass} data-tn="tpn-faq-question">
                        {this.props.questionCopy}
                    </div>
                    <div data-tn="toggle-faq-answer" onClick={toggleIconClick}>
                        {this.toggleIcon()}
                    </div>
                </div>
                {this.state.isExpanded && (
                    <div className={styles.answer} data-tn="tpn-faq-answer">
                        {this.props.children}
                    </div>
                )}
            </div>
        );
    }
}

EnvelopeLabel.propTypes = {
    children: PropTypes.node.isRequired,
    questionCopy: PropTypes.node.isRequired,
};
